<template>
  <div
    class="project-card-on-site"
    :style="`cursor: ${pointer ? 'pointer' : 'auto'};`"
    @click="$emit('clickAll')"
  >
    <!-- IMAGE -->
    <v-img
      class="project-card-on-site-image"
      v-if="image"
      :src="image"
      max-width="80"
      min-width="80"
      min-height="100"
      max-height="100"
    />
    <!-- gradient="to top, rgba(0,0,0,0), rgba(0,0,0,0.5)" -->

    <!-- FALL BACK -->
    <div v-else>
      <div
        class="project-card-on-site-image-fallback color-3 project-card-on-site-image"
      />
    </div>

    <!-- HEADER -->
    <div class="project-card-on-site-right-side">
      <div class="project-card-on-site-role-status">
        <div class="project-card-on-site-role-combination">
          <TIcon name="person" size="12"/>
          <TText :text="role" size="8"/>
        </div>
        <TText :text="status" size="8"/>
      </div>
      <TText
        :text="header"
        max_lines="1"
        font_weight="400"
      />

      <!-- ACTUAL INFOS -->
      <slot name="body"/>
    </div>

    <RadialCheckbox
      v-if="checkbox"
      class="project-card-on-site-checkbox"
      foreground_color="white"
      shadow="black"
      @click.native.prevent.stop="$emit('clickCheckbox')"
      :is_checked="is_checked"
    />
    <v-progress-circular
      v-if="loading"
      :size="60"
      width="6"
      indeterminate class="project-card-on-site-loading-circle white--text"
    />
  </div>
</template>

<script>
import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';

export default {
  props: [
    'header',
    'project',
    'is_checked',
    'checkbox',
    'image',
    'role',
    'status',
    'content_height',
    'loading',
  ],

  components: {
    RadialCheckbox,
    TText,
    TIcon,
  },

  data: () => ({
    checked: [],
  }),

  methods: {

  },

  computed: {
    pointer() {
      let a = this.$attrs;
      if(a.pointer !== undefined) {
        if(a.pointer || a.pointer === '')
          { return true; } }
      return false;
    },
  },
}
</script>

<style scoped>
.project-card-on-site {
  background-color: var(--v-color-6-base);
  border-radius: 4px;
  position: relative;
  display: flex;
  cursor: pointer;
}
.project-card-on-site-image {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.project-card-on-site-image-fallback {
  min-width: 80px;
  max-width: 80px;
  min-height: 100px;
  max-height: 100px;
}
.project-card-on-site-right-side {
  display: flex;
  flex-direction: column;
  padding: 8px;
  flex-grow: 1;
  grid-gap: 4px;
}
.project-card-on-site-role-status {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.project-card-on-site-role-combination {
  display: flex;
  align-items: center;
  grid-gap: 2px;
}
.project-card-on-site-header {
  width: 100%;
  background-position: center;
  background-size: cover;
}
.project-card-on-site-header-text {
  text-align: center;
  padding: 10px;
  height: 100%;
  width: 100%;
  text-shadow: 0px 1px #000;
  font-size: 20px;
  text-align: left;
}
.project-card-on-site-content {
  overflow: hidden;
  height: 200px;
}
.project-card-on-site-loading-circle {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.project-card-on-site-checkbox {
  position: absolute;
  top: 5px;
  right: 5px;
}
</style>
